// extracted by mini-css-extract-plugin
export default {"entityLink":"EntityLink_entityLink__ixft1"};